export var VALUE_PLACEHOLDER = '{V}';
export var CURRENCY_CODE_PLACEHOLDER = '{S}';
var getPrefixSpacedFormat = function (symbol) { return symbol + " " + VALUE_PLACEHOLDER; };
var getPrefixFormat = function (symbol) { return "" + symbol + VALUE_PLACEHOLDER; };
var getPostfixSpacedFormat = function (symbol) { return VALUE_PLACEHOLDER + " " + symbol; };
export var defaultCurrencyFormatConfig = {
    format: CURRENCY_CODE_PLACEHOLDER + " " + VALUE_PLACEHOLDER,
    decimalDigits: 2,
};
// TODO: compare decimalDigits information with back-end
export var currencyFormatConfig = {
    USD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    EUR: { format: getPrefixFormat('€'), decimalDigits: 2 },
    GBP: { format: getPrefixFormat('£'), decimalDigits: 2 },
    JPY: { format: getPrefixFormat('¥'), decimalDigits: 0 },
    AUD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    BRL: { format: getPrefixFormat('R$'), decimalDigits: 2 },
    CAD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    DKK: { format: getPostfixSpacedFormat('kr'), decimalDigits: 2 },
    HKD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    HUF: { format: getPrefixFormat('Ft'), decimalDigits: 2 },
    MYR: { format: getPrefixFormat('RM'), decimalDigits: 2 },
    MXN: { format: getPrefixFormat('$'), decimalDigits: 2 },
    TWD: { format: getPrefixFormat('NT$'), decimalDigits: 0 },
    NZD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    NOK: { format: getPostfixSpacedFormat('kr'), decimalDigits: 2 },
    SGD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    SEK: { format: getPostfixSpacedFormat('kr'), decimalDigits: 2 },
    CHF: { format: getPrefixFormat('CHF'), decimalDigits: 2 },
    RUB: { format: getPrefixSpacedFormat('руб.'), decimalDigits: 2 },
    ILS: { format: getPrefixFormat('₪'), decimalDigits: 2 },
};
//# sourceMappingURL=currency-format-config.js.map